import React from 'react';

export default function SectionTitle({ kicker, title, subtitle, center = false, light = false }) {
  const align = center ? 'text-center' : '';
  const titleColor = light ? 'text-white' : 'text-moj-purple-deep';
  const kickerColor = light ? 'text-moj-gold' : 'text-moj-gold-deep';
  const subtitleColor = light ? 'text-white/80' : 'text-moj-charcoal/80';
  return (
    <div className={`mb-10 ${align}`}>
      {kicker && (
        <div className={`text-xs sm:text-sm font-bold uppercase tracking-[0.25em] ${kickerColor} mb-3`}>{kicker}</div>
      )}
      <h2 className={`font-serif text-3xl sm:text-4xl lg:text-5xl ${titleColor} leading-tight`}>{title}</h2>
      {subtitle && (
        <p className={`mt-4 text-lg ${subtitleColor} max-w-3xl ${center ? 'mx-auto' : ''}`}>{subtitle}</p>
      )}
    </div>
  );
}
